import { render } from "./clipped.vue?vue&type=template&id=4ecb7724"
import script from "./clipped.vue?vue&type=script&lang=js"
export * from "./clipped.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__